module.exports = __webpack_public_path__ + "static/media/undraw_pie_chart_6efe.51b33136.svg";